'use strict';

module.exports = function () {
    return function () {
        function makeid() {
            var text = "";
            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for (var i = 0; i < 5; i++ ) {
                text += possible.charAt(Math.floor(Math.random() * possible.length));
            }
            return text;
        }
        return makeid();
    }
}


/** WEBPACK FOOTER **
 ** ./src/pages/services/generateid.js
 **/